import { faBriefcase } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { StyledIcon } from './index'

type AuditIconProps = {
  height?: number
  width?: number
  color?: string
}

export const AuditIcon = ({
  height,
  width,
  color,
}: AuditIconProps): JSX.Element => (
  <StyledIcon height={height} width={width}>
    <FontAwesomeIcon icon={faBriefcase} color={color} />
  </StyledIcon>
)
